<template>
  <div class="animationWrapper">
    <div ref="animationContainer" class="animationContainer" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'

// Services
import lottie from 'lottie-web'

// Stores
import { useDataStore } from '@/stores/DataStore'

const dataStore = useDataStore()
const { screenerTemplateId } = storeToRefs(dataStore)

const animationContainer = ref<HTMLElement | null>(null)
const animation = ref<any>(null)

const props = defineProps({
  animationName: {
    type: String,
    required: true
  },
  width: {
    type: String,
    default: '100%'
  },
  marginBottom: {
    type: String,
    default: '4rem'
  }
})

onMounted(() => {
  animation.value = lottie.loadAnimation({
    container: animationContainer.value as HTMLElement,
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path: `${_ASSETS_BUCKET_URL_}/${screenerTemplateId.value}/animations/${props.animationName}.json?v=${_ASSETS_VERSION_}`
  })

  animation.value.addEventListener('DOMLoaded', () => {
    const svg = animationContainer.value?.querySelector('svg')
    if (svg) {
      svg.style.width = '100%'
    }
  })
})

onBeforeUnmount(() => {
  animation.value?.destroy()
})
</script>

<style lang="scss" scoped>
.animationWrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: v-bind(marginBottom);
}

.animationContainer {
  width: v-bind(width);
}
</style>
